<template>
  <AppHeaderDropdown right caret>
    <template slot="header">
      <img :src="getProfilePic" class="img-avatar" :alt="user.user_name" />
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center">
        <strong>{{ accountTypes[user.user_type_id - 1] }} Account</strong>
      </b-dropdown-header>
      <b-dropdown-item to="/account/settings"
        ><i class="fa fa-wrench" /> General Settings</b-dropdown-item
      >
      <b-dropdown-item to="/account/ziga-units"
        ><i class="fa fa-cubes" /> Ziga Units</b-dropdown-item
      >
      <b-dropdown-item
        style="margin-bottom: 10px"
        to="/account/manage-newsletters"
        ><i class="fa fa-rss" /> Manage Newsletter</b-dropdown-item
      >

      <a
        v-if="user.user_type_id == 3"
        class="anchor-tag"
        href="https://admin.zigatext.com/login?redirect=%2Fdashboard"
        target="blank"
        ><i class="fa fa-rss anchor-tag-icon" /> Admin Portal Login</a
      >

      <b-dropdown-divider />
      <b-dropdown-item @click="handleLogout" to="#"
        ><i class="fa fa-lock" /> Logout</b-dropdown-item
      >
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
import { mapGetters, mapActions } from "vuex";
import { accountTypes } from "@/constants";

export default {
  name: "DefaultHeaderDropdownAccnt",
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {
      itemsCount: 42,
      accountTypes: accountTypes
    };
  },
  computed: {
    ...mapGetters("user", ["user"]),
    getProfilePic() {
      return this.user.profile.photo_url != ""
        ? this.user.profile.photo_url
        : "https://www.gravatar.com/avatar/default?s=200&r=pg&d=mm";
    }
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    handleLogout() {
      this.logout();
      document.body.classList.remove(
        "aside-menu-lg-show",
        "header-fixed",
        "sidebar-fixed"
      );
      window.location.reload();
    }
  }
};
</script>

<style scoped>
.anchor-tag-icon {
  margin-inline: 16px;
}
.anchor-tag {
  color: black;
}
</style>
